import { createSlice } from "@reduxjs/toolkit";
const customerSlice = createSlice({
  name: "customers",
  initialState: { customers: [] },
  reducers: {
    customersSuccess: (state, action) => {
      state.customers = action.payload;
    },
    clearCustomers: (state) => {
      state.customers = [];
    },
  },
});
export const { clearCustomers, customersSuccess } = customerSlice.actions;
export default customerSlice.reducer;
